import React, { useRef, useMemo, useState, useEffect } from 'react'
import { Divider, Paper } from '@mui/material';
import { Button } from '@mui/material';
import FormDialog from '../panel/modal';
import JoditEditor from 'jodit-react';
import Fab from '@mui/material/Fab';
import SaveIcon from '@mui/icons-material/Save';

import Swal from 'sweetalert2'
import axios from 'axios';
import api from '../../API/api';
import ViewCourses from '../table/viewCourses';
import { Link, useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Loader from '../panel/loader';
import Affiliation from './addAffiliation';

import { Helmet } from "react-helmet";


const AddCourse = () => {



    const navigation = useNavigate();
    const params = useParams()
    const school_id = params.s_id;

    const [courseOverview, setCourseOverview] = useState();
    const [careerOpportunities, setCareerOpportunities] = useState();
    const [test, setTest] = useState();

    const [formdata, setFormdata] = useState({
        courseName: '',
        shortName: '',
        duration: '',
        durationType: '',
        isInternship: '',
        eligibility: '',
        recognition: '',
        affilited: '',
        effected_from: '',
        effected_to: '',

    })
    const [open, setOpen] = React.useState(false);
    const [load, setLoad] = useState(false);
    const [modalData, setModalData] = useState()

    const [courses, setCourses] = useState();
    const [activeCourse, setActiveCourse] = useState();
    const [inactiveCourse, setInactiveCourse] = useState();
    const [school, setSchool] = useState();
    const [viewmore, setViewmore] = useState(false);
    const [openAffiliation, setOpenAffiliation] = React.useState(false);

    const [affiliations, setAffiliations] = useState();

    useEffect(() => {
        getCourses()
    }, []);
    useEffect(() => {
        getAffiliations()
    }, []);



    const getCourses = () => {
        setLoad(true)
        api.getCourses(school_id).then((res) => {
            setCourses(res.data.courses)
            setSchool(res.data.school)
            // console.log("www2", res.data.courses.filter((el)=> el.effected_to === 'present'));
            setActiveCourse(res.data.courses.filter((el) => el.effected_to === 'present'))
            setInactiveCourse(res.data.courses.filter((el) => el.effected_to !== 'present'))



            setLoad(false)
            // console.log(res);
        })
            .catch((err) => {
                // console.log(err.response);
            })

    }

    const getAffiliations = () => {
        api.getAffiliations().then((res) => {
            // console.log(res);
            setAffiliations(res.data.affiliations)
        })
            .catch((err) => {
                // console.log(err);
            })
    }



    const handleClickOpen = (data) => {
        // console.log("==>>", data);
        // return;
        setOpen(true);
        if (data) {
            setFormdata(data);
            setCareerOpportunities(data.careerOpportunities)
            setCourseOverview(data?.courseOverview)
        }
        setStep(1)
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleCourseoverview = (e) => {
        setCourseOverview(e)
    }
    const handleCareerOpportunities = (e) => {
        setCareerOpportunities(e)
    }

    const handleForm = (e) => {
        // console.log("==>", e.target.checked);
        if (e.target.name == "effected_to_check") {
            setFormdata({
                ...formdata,
                'effected_to': 'present'
            })

        } else {
            setFormdata({
                ...formdata,
                [e.target.name]: e.target.value
            })
        }
    }

    const handleViewmore = () => {
        setViewmore(!viewmore)
    }

    // copy course 
    const [openCopy, setOpenCopy] = useState(false)
    const CopyModelOpen = () => { setOpenCopy(true) }
    const CopyModelClose = () => { setOpenCopy(false) }
    const handleCopyCourse = (data) => {
        // console.log("Hey i'm here", data);
        CopyModelOpen();
        // setCopiedData(data)
        if (data) {
            setFormdata(data);
            setCareerOpportunities(data.careerOpportunities)
            setCourseOverview(data?.courseOverview)
        }
        setStep(1)
    }



    const submitData = () => {
        // console.log("s=>", formdata);
        // return;

        setLoad(true)
        const postData = new FormData();
        postData.append('id', formdata.id);
        postData.append('school_id', school_id);
        postData.append('courseName', formdata.courseName);
        postData.append('shortName', formdata.shortName);
        postData.append('duration', formdata.duration);
        postData.append('durationType', formdata.durationType);
        postData.append('isInternship', formdata.isInternship);
        postData.append('eligibility', formdata.eligibility);
        postData.append('recognition', formdata.recognition);
        postData.append('courseOverview', courseOverview);
        postData.append('careerOpportunities', careerOpportunities);
        postData.append('slug', formdata.courseName?.replace(/[^A-Z0-9]+/ig, "-"));

        postData.append('affilited', formdata.affilited);
        postData.append('effected_from', formdata.effected_from);
        postData.append('effected_to', formdata.effected_to);

        postData.append('copy', openCopy);

        axios.post(`${process.env.REACT_APP_MAIN_API}saveCourse`, postData)
            .then((res) => {
                // console.log("aa==>>", res.data);
                setLoad(false)
                // return;

                getCourses();
                handleClose();
                Swal.fire({
                    title: 'Success!',
                    text: res.data.message,
                    icon: 'success',
                    confirmButtonText: 'Ok'
                })
            })
            .catch((err) => {
                setLoad(false)
                // console.log(err.response);
            })
    }

    // jodit editor
    const editor = useRef(null);

    const config = {
        uploader: {
            insertImageAsBase64URI: true
        },
        height: 320,
        triggerChangeEvent: true,
        readonly: false,
    }


    const CourseOverviewEdit = () => {
        return useMemo(() => (
            <JoditEditor
                // ref={editor}
                config={config}
                value={courseOverview}
                onChange={handleCourseoverview}
            />
        ), [step])
    }

    const CareerOpportunitiesEdit = () => {
        return useMemo(() => (
            <JoditEditor
                // ref={editor}
                config={config}
                value={careerOpportunities}
                onChange={handleCareerOpportunities}
            />
        ), [step])
    }


    const [step, setStep] = useState(0);

    const nextStep = () => {
        switch (step) {
            case 1:
                return (
                    <>
                        {form1()}
                    </>
                )

            case 2:
                return (
                    <>
                        {form2()}
                    </>
                )
            case 3:
                return (
                    <>
                        {form2()}
                    </>
                )
            default:
                { form1() };
                break;
        }

    }

    const stepper = () => {
        return (
            <>
                <Paper>
                    <Divider sx={{ borderBottomWidth: '1px', borderBottomColor: 'black' }} />
                    <div className='row justify-content-center p-2'>

                        <Fab color={step === 1 ? 'secondary' : ''} size='small' variant="extended" aria-label="edit">
                            <div className="row">
                                <div> <small>1. Basic </small></div>
                            </div>
                        </Fab>
                        <Fab color={step === 2 ? 'secondary' : ''} size='small' variant="extended" aria-label="edit">
                            <div className="row">
                                <div> <small>2. Information </small></div>
                            </div>
                        </Fab>
                    </div>
                    <Divider sx={{ borderBottomWidth: '5px', borderBottomColor: 'black' }} />
                </Paper>
            </>
        )
    }



    const form1 = () => {

        return (
            <>
                <Paper elevation={3}>
                    <div className='p-3'>
                        <div className="row">
                            <div className="col-md-8 form-group p-2">
                                <label for=""> <b> Course Name </b></label>
                                <input type="text" className="form-control" id="" name='courseName' value={formdata.courseName} onChange={handleForm} placeholder="Enter Course Name" />
                            </div>

                            <div className="col-md-4 form-group p-2">
                                <label for=""> <b> Short Name </b></label>
                                <input type="text" className="form-control" id="" name='shortName' value={formdata.shortName} onChange={handleForm} placeholder="ex- GNM" />
                            </div>

                            <div className="col-md-4 form-group p-2">
                                <label for=""> <b> Duration </b></label>
                                <input type="number" className="form-control" id="" name='duration' value={formdata.duration} onChange={handleForm} />
                            </div>

                            <div className="col-md-4 form-group p-2">
                                <label for=""> <b> Duration Type </b></label>
                                <div className='d-flex align-items-center'>
                                    <input class="form-check-input" type="radio" value='year' checked={formdata.durationType === 'year' ? true : false} onClick={handleForm} name="durationType" id=""></input>Years &nbsp; &nbsp; &nbsp;
                                    <input class="form-check-input" type="radio" value='month' checked={formdata.durationType === 'month' ? true : false} onClick={handleForm} name="durationType" id=""></input>Months
                                </div>
                            </div>

                            <div className="col-md-4 form-group p-2">
                                <label for=""> <b> Internship included ? </b></label>
                                <div className='d-flex align-items-center'>
                                    <input class="form-check-input" type="radio" value='1' onClick={handleForm} checked={formdata.isInternship === "1" ? true : false} name="isInternship" id=""></input>Yes &nbsp; &nbsp; &nbsp;
                                    <input class="form-check-input" type="radio" value='0' onClick={handleForm} checked={formdata.isInternship === "0" ? true : false} name="isInternship" id=""></input>No
                                </div>
                            </div>


                            <div className="col-md-12 form-group p-2">
                                <label for=""> <b> Course Overview </b></label>
                                {CourseOverviewEdit()}
                            </div>

                        </div>

                        <div className='d-flex justify-content-between'>
                            <div>

                            </div>
                            <div>
                                <Button variant='contained' onClick={() => setStep(2)}>Next</Button>
                            </div>
                        </div>

                    </div>
                </Paper>
            </>
        )
    }

    const form2 = () => {
        return (
            <>
                <Paper elevation={3}>
                    <div className='p-3'>
                        <div className="row">

                            <div className="col-md-12 form-group p-2">
                                <label for="">Eligibility For the Course</label>
                                <input type="text" className="form-control" id="" name='eligibility' value={formdata.eligibility} onChange={handleForm} />
                            </div>
                            <div className="col-md-12 form-group p-2">
                                <label for="">Recognitions</label>
                                <input type="text" className="form-control" id="" name='recognition' value={formdata.recognition} onChange={handleForm} placeholder="" />
                            </div>

                            {/* **************************** */}

                            <div className="col-md-12 form-group p-2">
                                <label for="">Affilited to</label>
                                {/* <input type="text" className="form-control" id="" name='affilited' value={formdata.affilited} onChange={handleForm} placeholder="" /> */}

                                <select name="affilited" className='form-control' value={formdata.affilited} onChange={handleForm} id="">
                                    <option value="">--select--</option>
                                    {affiliations && affiliations.map((el) => (
                                        <option value={el.affiliation}>{el.affiliation}</option>
                                    ))}
                                </select>


                            </div>


                            <div className="col-md-6 form-group p-2">
                                <label for="">Affilited Effected from</label>
                                <input type="month" className="form-control" id="" name='effected_from' value={formdata.effected_from} onChange={handleForm} />
                            </div>
                            <div className="col-md-6 form-group p-2">
                                <label for="">
                                    Affilited Effected To &nbsp; (To Present &nbsp;
                                    <input type="checkbox" id="" name='effected_to_check' value={formdata.effected_to} onChange={handleForm} />
                                    )

                                </label>
                                <input type="month" className="form-control" id="" name='effected_to' value={formdata.effected_to} onChange={handleForm} />
                            </div>

                            <div className="col-md-12 form-group p-2">
                                <label for=""> <b> Career Opportunities </b></label>
                                {CareerOpportunitiesEdit()}
                            </div>
                        </div>
                        <div className='d-flex justify-content-between'>
                            <div>

                                <Button variant='contained' color='secondary' onClick={() => setStep(1)}>Previous</Button>
                            </div>
                            <div>
                                <Button variant='contained' color='success' disabled={load ? true : false} onClick={submitData}>Save  <SaveIcon fontSize='small' /></Button>
                            </div>
                        </div>
                    </div>
                </Paper>
            </>
        )
    }


    const form = () => {
        return (
            <>
                {stepper()}
                {nextStep()}
            </>
        )
    }




    return (
        <>

            <div className="row">
                <Paper>
                    <div className="col-12">
                        <Button variant='contained' className='m-2' onClick={() => navigation(-1)}>Back</Button>
                        <Button variant='contained' className='float-end m-2' onClick={handleClickOpen}>+Add Course</Button>
                        <Button variant='contained' className='float-end m-2' onClick={() => setOpenAffiliation(true)}>+Add Affiliation</Button>
                    </div>
                    <FormDialog form={form()} title='Add Course' open={open} handleClickOpen={handleClickOpen} handleClose={handleClose} />
                    {/* copy a course  */}
                    <FormDialog form={form()} title='Copy Course' open={openCopy} handleClickOpen={CopyModelOpen} handleClose={CopyModelClose} />

                    <FormDialog size='md' form={<Affiliation handleClose={() => setOpenAffiliation(false)} />} title='Add Affiliation' open={openAffiliation} handleClickOpen={() => setOpenAffiliation(true)} handleClose={() => setOpenAffiliation(false)} />

                </Paper>
                {load &&
                    <Loader />
                }
                <Paper>
                    <div className="col-12">
                        <ViewCourses courses={activeCourse} school={school} handleClickOpen={handleClickOpen} handleClose={handleClose} setModalData={setModalData} handleCopyCourse={handleCopyCourse} />
                    </div>
                    <div>
                        <div className='text-primary float-end p-2' onClick={handleViewmore}>
                            <Link>
                                {viewmore ? 'Hide' : 'View'} More Previous Session Course
                            </Link>
                        </div>
                    </div>
                </Paper>
                {viewmore &&
                    <Paper>
                        <div className="col-12">
                            <ViewCourses courses={inactiveCourse} school={{ schoolName: 'Inactive' }} handleClickOpen={handleClickOpen} handleClose={handleClose} setModalData={setModalData} handleCopyCourse={handleCopyCourse} />
                        </div>
                    </Paper>
                }
            </div>
        </>
    )
}

export default AddCourse;